import { telHref } from '@/utils/formatters';

export function handOffTelephone(phone: string): void { window.location.assign(telHref(phone)); }

// ─── Types ──────────────────────────────────────────────────────────────

export interface QueueLead {
  id: string;
  campaignId?: string;
  contactId: string;
  dealId?: string | null;
  callAttempts: number;
  lastCalledAt: string | null;
  priority?: number;
  campaign?: { id: string; name: string } | null;
  contact?: {
    id: string;
    firstName: string;
    lastName: string;
    phone?: string | null;
    mobile?: string | null;
    account?: { name: string } | null;
  } | null;
}

export interface TodayCall {
  id: string;
  status: string;
  duration: number;
  startTime: string | null;
  phoneNumber: string;
  disposition?: { id: string; name: string; color: string } | null;
  contact?: {
    firstName: string;
    lastName: string;
  } | null;
}

export interface FollowUp {
  id: string;
  contactId: string;
  scheduledAt: string;
  notes?: string | null;
  priority?: string;
  contact?: {
    firstName: string;
    lastName: string;
    phone?: string;
  } | null;
}

// ─── Helpers ────────────────────────────────────────────────────────────

export function fmtTime(dt?: string | null): string {
  if (!dt) return '-';
  const d = new Date(dt);
  return d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });
}

export function fmtDate(dt?: string | null): string {
  if (!dt) return '-';
  const d = new Date(dt);
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
}

export function fmtDur(sec: number): string {
  if (!sec) return '0:00';
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function statusColor(s: string): string {
  if (s === 'CONNECTED') return 'bg-green-50 text-green-700';
  if (s === 'MISSED' || s === 'NO_ANSWER') return 'bg-red-50 text-red-700';
  if (s === 'IN_PROGRESS' || s === 'RINGING') return 'bg-amber-50 text-amber-700';
  return 'bg-gray-100 text-gray-600';
}
